import Crop, { CropsWithCategoryProps } from '@dehaat/kisan-app-bl/models/CropV2';
import { useEffect, useRef, useState } from 'react';
import CaretDownIcon from '@/components/icons/CaretDownIcon';
import RightIcon from '@/components/icons/RightIcon';
import SubHeading from '@/components/SubHeading';
import LazyImage from './LazyImage';
import SampleCropDisplay from './SampleCropDisplay';
interface Props {
  cropCategory: CropsWithCategoryProps;
  crops: number[];
  onClick: (crop: Crop) => void;
}
const CropCategoryAccordion = ({
  cropCategory,
  crops,
  onClick
}: Props) => {
  const accordionRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    if (accordionRef.current) {
      if (isOpen) {
        // Add the vertical padding '32px'
        accordionRef.current.style.maxHeight = accordionRef.current.scrollHeight + 32 + 'px';
      } else {
        accordionRef.current.style.maxHeight = '0';
      }
    }
  }, [isOpen]);
  return cropCategory.crops.length > 0 ? <section className="bg-neutral-20 overflow-hidden rounded" data-sentry-component="CropCategoryAccordion" data-sentry-source-file="CropCategoryAccordion.tsx">
      <button className="bg-white capitalize flex inline-block items-center justify-between p-4 w-full" onClick={() => setIsOpen(prev => !prev)}>
        <SubHeading className="text-neutral-80" data-sentry-element="SubHeading" data-sentry-source-file="CropCategoryAccordion.tsx">
          {cropCategory.category}
        </SubHeading>
        <CaretDownIcon className={`duration-300 ease-in-out h-4 transition-all w-4 ${isOpen ? '-rotate-180' : 'rotate-0'}`} data-sentry-element="CaretDownIcon" data-sentry-source-file="CropCategoryAccordion.tsx" />
      </button>
      <div className={`duration-300 ease-in-out gap-4 grid grid-cols-3 justify-items-center md:grid-cols-5 overflow-hidden px-4 transition-all ${isOpen ? 'py-4' : 'py-0'}`} ref={accordionRef}>
        {cropCategory.crops.map(crop => <button className="flex flex-col items-center relative" key={crop.id} data-testid={`accordion-crop-${crop.id}`} onClick={() => onClick(crop)}>
            <div className="border border-neutral-40 h-20 overflow-hidden relative rounded-full w-20 text-2xl">
              <LazyImage alt={crop.app_display_name} fallBackIcon={<SampleCropDisplay name={crop.app_display_name[0]} />} imageUrl={crop.image_url} className="h-20 w-20 rounded-full" />
            </div>
            <p className="mt-1 text-center">{crop.app_display_name}</p>
            {crops.includes(crop.id) && <div className="absolute bg-primary-100 h-6 px-1 pt-1.5 right-0 rounded-full w-6" data-testid="check-icon">
                <RightIcon className="fill-white stroke-white" width={16} />
              </div>}
          </button>)}
      </div>
    </section> : null;
};
export default CropCategoryAccordion;